export default "__VITE_ASSET__DKpgFXVr__"